/* eslint-disable @typescript-eslint/naming-convention */
import { useCallback, useState } from "react";

import { SELECTED_FLAG } from "../constants";
import { LanguageDefault } from "../util/enums";

export default function useActiveFlag() {
  const [activeFlag, _setActiveFlag] = useState<string>(
    window.localStorage.getItem(SELECTED_FLAG) || LanguageDefault.AU
  );

  const setActiveFlag = useCallback((flag: string) => {
    window.localStorage.setItem(SELECTED_FLAG, flag);
    _setActiveFlag(flag);
  }, []);

  return [activeFlag, setActiveFlag] as const;
}
